import { useEffect, useMemo, useState } from 'react'
import { ChevronLeft, ChevronRight, Pause, Play } from 'lucide-react'
import { Link } from 'react-router-dom'
import { notices } from '../data/content'
import { formatToday } from '../services/storage'

export default function NoticeTicker() {
  const activeNotices = useMemo(() => {
    const now = new Date()
    return notices.filter((n) => now >= new Date(n.startAt) && now <= new Date(`${n.endAt}T23:59:59`)).sort((a, b) => Number(b.pinned) - Number(a.pinned) || b.priority - a.priority)
  }, [])
  const [index, setIndex] = useState(0)
  const [playing, setPlaying] = useState(true)
  useEffect(() => {
    if (!playing || activeNotices.length < 2) return
    const timer = window.setInterval(() => setIndex((v) => (v + 1) % activeNotices.length), 5200)
    return () => clearInterval(timer)
  }, [playing, activeNotices.length])
  if (!activeNotices.length) return null
  const item = activeNotices[index]
  const text = item.content.replace('{{today}}', formatToday())
  return <section className="notice-strip" aria-label="博物馆公告" onMouseEnter={() => setPlaying(false)} onMouseLeave={() => setPlaying(true)}>
    <div className="notice-kicker"><span/>公告</div>
    <div className="notice-content" aria-live="polite"><b className={`notice-tag tag-${item.category}`}>{item.category}</b><Link to={item.link}>{text}</Link></div>
    <div className="notice-controls"><span>{String(index + 1).padStart(2, '0')} / {String(activeNotices.length).padStart(2, '0')}</span><button onClick={() => setIndex((index - 1 + activeNotices.length) % activeNotices.length)} aria-label="上一条公告"><ChevronLeft/></button><button onClick={() => setPlaying(!playing)} aria-label={playing ? '暂停轮播' : '继续轮播'}>{playing ? <Pause/> : <Play/>}</button><button onClick={() => setIndex((index + 1) % activeNotices.length)} aria-label="下一条公告"><ChevronRight/></button></div>
  </section>
}
